import localforage from 'localforage';
import Depot from '@/models/Depot';

export default () => {
  localforage.config({
    driver: localforage.INDEXEDDB,
    name: 'Rentrunner',
    version: 1.0,
    storeName: 'RentrunnerDB', // Should be alphanumeric, with underscores.
    description: 'Local DB storage for various models'
  });
}

export const LocalForageKey = {
  INITIAL_SEARCH_DEPOTS: 'INITIAL_SEARCH_DEPOTS',
  INITIAL_SEARCH_TIMESTAMPS: 'INITIAL_SEARCH_TIMESTAMPS',
}

export class Localforage {

  static getDepots(key = 'general') {
    return new Promise((resolve, reject) => {
      localforage.getItem(LocalForageKey.INITIAL_SEARCH_DEPOTS, (err, val) => {
        val = val || {};
        resolve(Depot.list(val[key] || []));
      })
    })
  }

  static saveDepots(depots, key, timestamp) {
    return Localforage.setTs(timestamp, key).then(() => {
      return Localforage.setDepots(depots, key)
    })
  }

  static setDepots(depots, key) {
    return localforage.getItem(LocalForageKey.INITIAL_SEARCH_DEPOTS, (err, val) => {
      val = val || {};
      val[key || 'general'] = depots;

      return localforage.setItem(LocalForageKey.INITIAL_SEARCH_DEPOTS, val);
    })
  }

  static deleteDepotIds(ids, key, ts) {
    return new Promise((resolve, reject) => {
      return Localforage.getDepots(key).then((depots) => {

        depots = depots.filter(item => ids.indexOf(item.id) == -1);

        Localforage.saveDepots(depots, key).then(() => {
          resolve(depots);
        });
      })
    })
  }

  static updateDepots(depotsUpdated, key, ts) {
    return new Promise((resolve, reject) => {
      return Localforage.getDepots(key).then((depots) => {

        depotsUpdated.forEach(depot => {
          const index = depots.findIndex(item => item.id == depot.id);
          if (index > -1) depots[index] = depot;
          else depots.push(depot);
        });

        Localforage.saveDepots(depots, key, ts).then(() => {
          resolve(depots);
        });
      })
    })
  }

  static getTs(key = 'general') {
    return new Promise((resolve, reject) => {
      localforage.getItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS, (err, val) => {
        val = val || {};

        resolve(val[key]);
      })
    })
  }

  static setTs(timestamp, key) {
    return localforage.getItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS, (err, val) => {
      val = val || {};
      if (timestamp) {
        val[key || 'general'] = timestamp;
      }

      return localforage.setItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS, val);
    })
  }
}
